import { useState, useEffect } from "react";
import { Input, Alert, Modal, Button } from "antd";
import { demandeAuthorization, toGetCode, toValidateCode } from "../Compte/Api";
import { errorMsg } from "../../Utils/Utils";

const ModalCode = ({
  onOk,
  isAdminModalVisible,
  setAdminModalVisible,
  text,
  type,
  client,
  clientId,
}) => {
  const [adminCode, setAdminCode] = useState("");
  const [code, setCode] = useState("");
  const [wrongAdminCode, setWrongAdminCode] = useState(false);
  const [disabled, setDisabled] = useState(false);
  useEffect(() => {
    toGetCode().then((res) => {
      setCode(res.code);
    });
  }, [isAdminModalVisible, text]);

  const save = () => {
    setDisabled(true);
    toValidateCode(adminCode).then((res) => {
      if (res === -1) {
        setWrongAdminCode(true);
      } else {
        onOk(res);
      }
      setDisabled(false);
    });
  };

  return (
    <Modal
      title="Operation non autorisée"
      visible={isAdminModalVisible}
      footer={[
        <Button key="close" onClick={() => setAdminModalVisible(false)}>
          Cancel
        </Button>,
        <Button key="submit" disabled={disabled} type="primary" onClick={save}>
          Ok
        </Button>,
      ]}
      onOk={save}
      onCancel={() => setAdminModalVisible(false)}
    >
      <p>{text}</p>
      {wrongAdminCode && (
        <Alert
          message="Code admin incorrect"
          type="error"
          style={{ marginBottom: 10 }}
        />
      )}
      {type != 1 && (
        <Input
          autoComplete="new-password"
          placeholder="Code admin"
          type="password"
          onChange={(e) => setAdminCode(e.target.value)}
        />
      )}
      {type === 1 && (
        <Button
          type="primary"
          onClick={() => {
            demandeAuthorization(client.id).then((res) => {
              if (!res) {
                errorMsg("Votre demande a été refusée");
              }
            });
            setAdminModalVisible(false);
          }}
          style={{ marginTop: "20px", textAlign: "center" }}
        >
          Demander l'autorisations
        </Button>
      )}
    </Modal>
  );
};
export default ModalCode;
